//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'maternal_special_meal',
  data() {
    // 获取当天日期，格式：YYYY-MM-DD
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    month = month < 10 ? ('0' + month) : month;
    let day = today.getDate();
    day = day < 10 ? ('0' + day) : day;
    const todayDate = year + '-' + month + '-' + day;
    
    return {
      date: todayDate, // 默认设置为当天日期
      tag: '',
      warning_level: '1', // 预警等级：1-低级（默认），2-中级，3-高级，4-紧急
      // 预警等级选项
      warningLevelOptions: [
        { value: '1', label: '关注' },
        { value: '2', label: '提醒' },
        { value: '3', label: '紧急' },
        { value: '4', label: '特急' }
      ],
      remark: '',
      agent_list: [],
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      agent_id: '', // 默认汇报人，在 created 中设置为当前登录用户
      agent_list: [],
      department_id: 790, //餐饮部，暂时写死
      departmentSelected: '',
      positionSelected: '',
      showPositionPicker: false,
      showAgentPicker: false,
      postdepartment: [],
      departments: [],
      department: '',
      positions: [],
      position: '',
      agents: [],
      agent: '',
      selectDpId: '',
      selectPsId: '',
      selectAgId: '',
      selectAgent: [],
    }
  },

  methods: {
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId() {
      const orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        const ids = orderTotalId.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id));
        if (ids.length > 0) {
          return Math.max(...ids).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },
    confirm() {

      // 日期已经有默认值，不需要再检查是否为空
      // if (this.date == '') {
      //   this.$vux.toast.show({
      //     type: 'cancel',
      //     text: '请选择日期',
      //   });
      //   return false;
      // }

      // 验证汇报人是否已选择
      // 检查 agent_id 是否为空字符串、null、undefined
      // 注意：使用 == '' 可以同时匹配 '' 和 null/undefined，但为了更严格，使用 ===
      const agentIdEmpty = this.agent_id === '' || this.agent_id === null || this.agent_id === undefined || String(this.agent_id).trim() === ''
      
      if (agentIdEmpty) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择汇报人',
        });
        return false;
      }


      if (this.tag == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择特殊标签',
        });
        return false;
      }

      if (this.remark == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请填写备注',
        });
        return false;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        date: this.date,
        department_id: this.department_id,
        agent_id: this.agent_id,
        tag_id: this.tag,
        warning_level: this.warning_level, // 预警等级
        remark: this.remark,
        agent_ids: this.selectAgent.map(agent => agent.id),
      }
     // console.log('params', params);
      Api.otherFormApi.specialReportAddMeal(params).then(res => {
      //  console.log('res', res);
        this.$vux.loading.hide()

        if (res.errcode == 1) {
          this.$vux.toast.show({
            type: 'success',
            text: '提交成功',
          });

          setTimeout(() => {
            this.goBack();
          }, 1000);

        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          });
        }
      }).catch(err => {
      //  console.error('API 请求失败:', err);
        this.$vux.loading.hide();
        // 显示详细的错误信息
        let errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = `提交失败: ${err.response.status} ${err.response.statusText}`;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = `提交失败: ${err.message}`;
        }
        this.$vux.toast.show({
          type: 'cancel',
          text: errorMsg,
        });
      });
    },
    apiSpecialReportMeal() {
      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
      }
      Api.otherFormApi.getSpecialReportMeal(params).then(res => {
       // console.log('res', res);
        if (res.errcode == 1) {
// 清空现有数据，避免数据残留
          this.tag_List = [];
          this.agent_list = [];

   // 从接口返回数据中获取汇报人列表和特殊标签列表
       
          this.agent_list = res.data.agent_list;
          this.tag_List = res.data.tag_List;

 // 为特殊标签列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.name）
       
          this.tag_List.forEach(element => {
            element.key = element.id,
              element.value = element.name
          });
          
          // 为汇报人列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.user_name）
          this.agent_list.forEach(element => {
            element.key = element.id,
              element.value = element.user_name
          });
          
          // 检查当前用户是否在汇报人列表中
          // 如果 agent_id 已设置（在 created 钩子中默认设置为当前登录用户ID）
          if (this.agent_id) {
            // console.log('this.agent_id', this.agent_id)
            // 在汇报人列表中查找当前用户
            const currentAgent = this.agent_list.find(item => {
              const itemValue = item.key || item.id
              return String(itemValue) === String(this.agent_id)
            })
            // console.log('currentAgent', currentAgent)
    
            if (currentAgent) {
              // 如果当前用户在列表中，说明可以正常显示和选择
              // 注意：这里不需要设置 agent_id，因为它已经在 created 钩子中设置为当前用户ID了
              // 选择器组件会自动根据 agent_id 的值匹配对应的选项
            } else {
              // 如果当前用户不在汇报人列表中，清空 agent_id，让用户手动选择
              // 这样可以避免选择器显示异常（选中一个不在选项中的值）
              this.agent_id = ''
              console.log('当前用户不在汇报人列表中，已清空默认选择')
            
              
              // 注意：由于 selector 组件使用了 v-model="agent_id"（第7行），
              // Vue 的响应式系统会自动检测到 agent_id 的变化并更新组件显示
              // 不需要手动调用 $forceUpdate() 或 $nextTick()，v-model 会自动处理更新
            }
          }
          
          // 隐藏加载提示
          this.$vux.loading.hide()
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          });
        }
      });
    },
    apiDeportment() {
      var params = {
        token: this.$cookie.get('token')
      }
      Api.otherFormApi.getDepartmentList(params).then(res => {
        console.log('res', res);
        if (res.errcode == 1) {
          this.departments = res.data;
          this.departments.forEach(element => {
            element.key = element.id,
              element.value = element.name
          });
          this.$vux.loading.hide()
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          });
        }
      });
    },

    apiAgentList() {
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      }
      Api.otherFormApi.getAgentList(params).then(res => {
        console.log('res', res);
        if (res.errcode == 1) {
          this.agents = res.data
          this.agents.forEach(element => {
            element.key = element.id,
              element.value = element.user_name
          });
          this.$vux.loading.hide()
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          });
        }
      });
    },

    apiPostionList(department_id) {
      var params = {
        token: this.$cookie.get('token'),
        department_id: department_id,
      }
      Api.otherFormApi.getPositionList(params).then(res => {
        if (res.errcode == 1) {
          this.positions = res.data;
          this.positions.forEach(element => {
            element.key = element.id,
              element.value = element.name
          })
          this.$vux.loading.hide()
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          });
        }
      });
    },


    showChageAgent() {
      this.showChangeAgentPanel = true
    },
    dialog_cancel() {
      this.showChangeAgentPanel = false
    },
    chooseAgent() {
      // 实现员工选择逻辑

    },

    cancel() {
      // 实现取消逻辑
      this.goBack()
    },
    submitForm() {

    },
    goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      })
    },
    changeAgents(value, key) {
      this.selectAgId = value;
      console.log(value, key)
    },
    dialog_confirm() {
      this.showChangeAgentPanel = false;
      var selectAg = this.agents.find(agent => agent.id === this.selectAgId)
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent)
    },
    changeDepartment(value) {
      console.log('选择了部门', value)
      this.selectDpId = value;
      this.apiPostionList(value)
    },
    changePositions(value) {
      console.log('选择了职位', value)
      this.selectPsId = value;
      this.apiAgentList()
    },
    removeAgent(agentId){
      console.log('删除',agentId)
      const index = this.selectAgent.findIndex(agent => agent.id === agentId);
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    },
    //转base64
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    },
  },
  created() {
    // 默认设置汇报人为当前登录用户
    const currentUserId = this.$cookie.get('id')
    if (currentUserId) {
      this.agent_id = currentUserId
    }
    
    this.apiSpecialReportMeal();
    this.apiDeportment();
    // this.apiAgentList();
  },
}



// WEBPACK FOOTER //
// ./src/components/maternal_special_meal.vue